<template>
  <div>
    <v-dialog v-model="dialog" eager persistent scrollable fullscreen>
      <v-form ref="ClassSetForm" @submit.prevent>
        <v-card>
          <v-card-title class="d-flex align-center">
            <span>{{ action }} Class Set</span>
            <v-spacer></v-spacer>
            <v-btn icon="mdi-close" variant="text" @click="closeD()"> </v-btn>
          </v-card-title>

          <v-card-text class="mt-4">
            <v-row>
              <v-col cols="12">
                <v-text-field
                  v-model="setName"
                  label="Set Name"
                  :rules="[formRules.required]"
                  variant="outlined"
                  density="compact"
                  class="rounded-lg"
                  :disabled="action == 'Update'"
                  :color="$vuetify.theme.themes.light.inputColor"
                />
              </v-col>
              <v-col cols="6">
                <v-autocomplete
                  v-model="program_id"
                  :rules="[formRules.required]"
                  :items="programsList"
                  item-value="id"
                  item-title="name"
                  label="Please Select Program"
                  variant="outlined"
                  density="compact"
                  class="rounded-lg"
                  :disabled="action == 'Update'"
                  :color="$vuetify.theme.themes.light.inputColor"
                ></v-autocomplete>
              </v-col>
              <v-col cols="6">
                <v-autocomplete
                  v-model="batch_selected"
                  :disabled="action == 'Update'"
                  @update:modelValue="showAddBatch"
                  :rules="[formRules.required]"
                  :items="batchList"
                  item-value="id"
                  :item-title="
                    (item) =>
                      item.year != ''
                        ? `${item.name}  (${item.year})`
                        : `${item.name}`
                  "
                  label="Please Select Batch"
                  variant="outlined"
                  density="compact"
                  class="rounded-lg"
                  :color="$vuetify.theme.themes.light.inputColor"
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" v-if="entry_type == 1">
                <v-file-input
                  @change="parseCSV()"
                  clearable
                  label="Upload Student List"
                  accept=".csv"
                  variant="outlined"
                  density="compact"
                  v-model="csv_file"
                ></v-file-input>
              </v-col>
            </v-row>

            <v-card
              class="my-5 dt-container"
              elevation="0"
              outlined
              v-if="entry_type == 1"
            >
              <div class="text-h4" v-if="!parsed && csv_file">Loading...</div>
              <v-data-table
                v-if="parsed && fetched_data.length > 0"
                :headers="action == 'Add' ? headers : headers1"
                :items="fetched_data"
                :loading="loading"
                hover
                :items-per-page="-1"
                density="compact"
                class="rounded-lg"
              >
                <template v-slot:[`item.bdate`]="{ item }">
                  {{ formatDate(item.bdate) }}
                </template>
                <template v-slot:[`item.canBeAdded`]="{ item }">
                  <v-chip
                    size="x-small"
                    :color="
                      item.studentExist
                        ? item.canBeAdded
                          ? 'green'
                          : 'red'
                        : 'warning'
                    "
                    >{{
                      item.studentExist
                        ? item.canBeAdded
                          ? "OK"
                          : "Already added from other set"
                        : "Student Not Found"
                    }}</v-chip
                  >
                </template>
                <template v-slot:[`item.actions`]="{ item, index }">
                  <v-btn
                    color="red"
                    class="white--text"
                    size="x-small"
                    @click="remove(item, index)"
                    rounded
                  >
                    remove
                  </v-btn>
                </template>
              </v-data-table>
            </v-card>

            <v-card
              class="my-5 dt-container"
              elevation="0"
              outlined
              v-if="entry_type == 2"
            >
              <v-card-text class="d-flex justify-end pb-0">
                <v-btn
                  :color="$vuetify.theme.themes.light.submitBtns"
                  class="white--text"
                  density="comfortable"
                  variant="flat"
                  rounded="pill"
                  @click="addData()"
                >
                  <v-icon start>mdi-plus</v-icon>
                  Add Student
                </v-btn>
              </v-card-text>
              <v-data-table
                :headers="action == 'Add' ? headers : headers1"
                :items="students_data"
                :loading="loading"
                hover
                :items-per-page="-1"
                density="compact"
                class="rounded-lg"
              >
                <template v-slot:[`item.bdate`]="{ item }">
                  {{ formatDate(item.bdate) }}
                </template>
                <template v-slot:[`item.canBeAdded`]="{ item }">
                  <v-chip
                    size="x-small"
                    :color="
                      item.studentExist
                        ? item.canBeAdded
                          ? 'green'
                          : 'red'
                        : 'warning'
                    "
                    >{{
                      item.studentExist
                        ? item.canBeAdded
                          ? "OK"
                          : "Already added from other set"
                        : "Student Not Found"
                    }}</v-chip
                  >
                </template>
                <template v-slot:[`item.actions`]="{ item, index }">
                  <v-btn
                    color="red"
                    class="white--text"
                    size="x-small"
                    @click="remove(item, index)"
                    rounded
                  >
                    remove
                  </v-btn>
                </template>
              </v-data-table>
            </v-card>
          </v-card-text>
          <v-divider></v-divider>

          <v-card-actions class="pa-2 mr-4">
            <v-spacer></v-spacer>
            <v-btn color="red" outlined @click="closeD()">
              <v-icon>mdi-close-circle-outline</v-icon>
              Cancel
            </v-btn>
            <v-btn
              :color="$vuetify.theme.themes.light.submitBtnsGreen"
              class="white--text"
              density="comfortable"
              variant="flat"
              :disabled="btnLoading"
              :loading="btnLoading"
              @click="action == 'Add' ? save() : update()"
            >
              <v-icon>mdi-check-circle</v-icon>
              Save
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
    <SkillAssessmentBatchDialog
      :data="batch_group"
      :action="'Add'"
      :batchToAdd="2"
    />

    <v-dialog v-model="dialogConfirmDelete" max-width="500">
      <v-card>
        <v-card-title class="text-h6">Warning</v-card-title>
        <v-card-text class="text-body-1">
          Are you sure you want to remove this student in the list?
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn variant="text" @click="dialogConfirmDelete = false"
            >Cancel</v-btn
          >
          <v-btn color="error" class="white--text" @click="proceedDelete"
            >Confirm</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="entrytypeDialog" eager persistent max-width="480">
      <v-card class="rounded-xl">
        <v-card-title class="d-flex align-center px-6 pt-5">
          <span class="text-h6 font-weight-bold">{{ action }} Students</span>
          <v-spacer></v-spacer>
          <v-btn
            icon="mdi-close"
            variant="text"
            @click="entrytypeDialog = false"
          ></v-btn>
        </v-card-title>
        <v-card-subtitle class="px-6 pb-2"
          >Choose how you'd like to add students</v-card-subtitle
        >

        <v-card-text class="px-6 pb-6">
          <v-row dense>
            <v-col cols="6">
              <v-card
                rounded="lg"
                class="pa-5 text-center entry-option"
                :style="{
                  backgroundColor: $vuetify.theme.themes.light.submitBtns,
                }"
                @click="
                  entry_type = 1;
                  entrytypeDialog = false;
                "
                style="cursor: pointer"
              >
                <v-icon size="32" color="white">mdi-file-upload-outline</v-icon>
                <div class="text-body-2 font-weight-bold text-white mt-3">
                  Batch Upload
                </div>
                <div
                  class="text-caption"
                  style="color: rgba(255, 255, 255, 0.85)"
                >
                  Import via CSV file
                </div>
              </v-card>
            </v-col>
            <v-col cols="6">
              <v-card
                rounded="lg"
                class="pa-5 text-center entry-option"
                :style="{
                  backgroundColor: $vuetify.theme.themes.light.inputColor,
                }"
                @click="
                  entry_type = 2;
                  entrytypeDialog = false;
                "
                style="cursor: pointer"
              >
                <v-icon size="32" color="white"
                  >mdi-account-plus-outline</v-icon
                >
                <div class="text-body-2 font-weight-bold text-white mt-3">
                  Manual Entry
                </div>
                <div
                  class="text-caption"
                  style="color: rgba(255, 255, 255, 0.85)"
                >
                  Add students one by one
                </div>
              </v-card>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="studentDialog" eager persistent max-width="500">
      <v-form ref="ManualStudentForm" @submit.prevent>
        <v-card class="rounded-xl">
          <v-card-title class="d-flex align-center px-6 pt-5">
            <span class="text-h6 font-weight-bold">
              {{ internal_action == "Add" ? "Add New" : "Update" }} Student
            </span>
            <v-spacer></v-spacer>
            <v-btn
              icon="mdi-close"
              variant="text"
              @click="studentDialog = false"
            ></v-btn>
          </v-card-title>

          <v-card-text class="mt-2 px-6">
            <v-row>
              <!-- <v-col cols="12">
                <v-text-field
                  v-model="student_id"
                  @keyup="findStudent"
                  :rules="[formRules.required]"
                  label="Student School Id"
                  prepend-inner-icon="mdi-identifier"
                  variant="outlined"
                  density="compact"
                  rounded="lg"
                  :color="$vuetify.theme.themes.light.inputColor"
                ></v-text-field>
                <div class="d-flex align-center text-caption" v-if="searching">
                  asdas
                  <v-progress-circular
                    indeterminate
                    size="14"
                    width="2"
                    class="mr-2"
                  ></v-progress-circular>
                  Searching...
                </div>

                <v-chip
                  v-if="search_output == 'found'"
                  size="small"
                  color="warning"
                  variant="tonal"
                  prepend-icon="mdi-alert-circle-outline"
                  class="mt-1"
                >
                  {{ search_output }}
                </v-chip>
                <div v-else-if="searching == null"></div>
                <v-chip
                  v-else
                  size="small"
                  color="success"
                  variant="tonal"
                  prepend-icon="mdi-information-outline"
                  class="mt-1"
                >
                  Student can be added to your class/set.
                </v-chip>
              </v-col> -->

              <v-col cols="12">
                <v-text-field
                  v-model="student_id"
                  @keyup="findStudent"
                  :rules="[formRules.required]"
                  label="Student School Id"
                  prepend-inner-icon="mdi-identifier"
                  variant="outlined"
                  density="compact"
                  rounded="lg"
                  :color="$vuetify.theme.themes.light.inputColor"
                ></v-text-field>

                <div class="d-flex align-center text-caption" v-if="searching">
                  <v-progress-circular
                    indeterminate
                    size="14"
                    width="2"
                    class="mr-2"
                  ></v-progress-circular>
                  Searching...
                </div>

                <template v-else-if="student_id && search_output">
                  <v-chip
                    v-if="search_output == 'found'"
                    size="small"
                    color="success"
                    variant="tonal"
                    prepend-icon="mdi-information-outline"
                    class="mt-1"
                  >
                    Student can be added to your class/set.
                  </v-chip>
                  <v-chip
                    v-else
                    size="small"
                    color="warning"
                    variant="tonal"
                    prepend-icon="mdi-alert-circle-outline"
                    class="mt-1"
                  >
                    {{ search_output }}
                  </v-chip>
                </template>
              </v-col>
              <v-col cols="12" v-if="search_output == 'found'">
                <v-text-field
                  v-model="email"
                  :rules="search_output == 'found' ? [formRules.required] : []"
                  label="Student Email"
                  prepend-inner-icon="mdi-email-outline"
                  variant="outlined"
                  density="compact"
                  rounded="lg"
                  :color="$vuetify.theme.themes.light.inputColor"
                />
              </v-col>
              <v-col cols="12" v-if="search_output == 'found'">
                <v-text-field
                  v-model="fname"
                  :rules="search_output == 'found' ? [formRules.required] : []"
                  label="Student First Name"
                  prepend-inner-icon="mdi-account-outline"
                  variant="outlined"
                  density="compact"
                  rounded="lg"
                  :color="$vuetify.theme.themes.light.inputColor"
                />
              </v-col>
              <v-col cols="12" v-if="search_output == 'found'">
                <v-text-field
                  v-model="mname"
                  label="Student Middle Name"
                  prepend-inner-icon="mdi-account-outline"
                  variant="outlined"
                  density="compact"
                  rounded="lg"
                  :color="$vuetify.theme.themes.light.inputColor"
                />
              </v-col>
              <v-col cols="12" v-if="search_output == 'found'">
                <v-text-field
                  v-model="lname"
                  :rules="search_output == 'found' ? [formRules.required] : []"
                  label="Student Last Name"
                  prepend-inner-icon="mdi-account-outline"
                  variant="outlined"
                  density="compact"
                  rounded="lg"
                  :color="$vuetify.theme.themes.light.inputColor"
                />
              </v-col>
              <v-col cols="12" v-if="search_output == 'found'">
                <v-text-field
                  v-model="suffix"
                  label="Student Suffix"
                  prepend-inner-icon="mdi-account-outline"
                  variant="outlined"
                  density="compact"
                  rounded="lg"
                  :color="$vuetify.theme.themes.light.inputColor"
                />
              </v-col>
              <v-col cols="12" v-if="search_output == 'found'">
                <v-select
                  v-model="sex"
                  :items="['Male', 'Female']"
                  label="Sex"
                  prepend-inner-icon="mdi-gender-male-female"
                  variant="outlined"
                  density="compact"
                  rounded="lg"
                  class="mb-2"
                  :color="$vuetify.theme.themes.light.inputColor"
                />
              </v-col>
            </v-row>
          </v-card-text>

          <v-card-actions class="pa-4" v-if="search_output == 'found'">
            <v-spacer></v-spacer>
            <v-btn
              variant="outlined"
              rounded="pill"
              color="error"
              @click="studentDialog = false"
            >
              Cancel
            </v-btn>
            <v-btn
              :color="$vuetify.theme.themes.light.submitBtns"
              class="white--text"
              density="comfortable"
              variant="flat"
              rounded="pill"
              @click="saveData()"
            >
              <v-icon start>mdi-check</v-icon>
              Add
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>

    <fade-away-message-component
      displayType="default"
      v-model="fadeAwayMessage.show"
      :message="fadeAwayMessage.message"
      :header="fadeAwayMessage.header"
      :type="fadeAwayMessage.type"
    ></fade-away-message-component>
  </div>
</template>

<script>
import eventBus from "@/eventBus";
import Papa from "papaparse";
import SkillAssessmentBatchDialog from "./SkillAssessment/SkillAssessmentBatchDialog.vue";
export default {
  props: {
    data: Object,
    action: String,
  },
  data() {
    return {
      dialogConfirmDelete: false,
      dialog: false,
      itemToDelete: null,
      indexToDelete: null,
      exceldata: [],
      program_id: null,
      email: null,
      address: null,
      batch_selected: null,
      batch: null,
      batch_year: null,
      batch_group: null,
      batchList: [],
      program_tied_id: null,
      setName: null,
      btnLoading: false,
      loading: false,
      csv_results: [],
      csv_file: null,
      parsed: false,
      headers: [
        { title: "School Id", value: "school_id", align: "start" },
        { title: "First Name", value: "fname", align: "start" },
        { title: "Middle Name", value: "mname", align: "start" },
        { title: "Last Name", value: "lname", align: "start" },
        { title: "Suffix", value: "suffix", align: "start" },
        { title: "Status", value: "canBeAdded", align: "center" },

        {
          title: "Actions",
          value: "actions",
          align: "center",
          sortable: false,
          width: 200,
        },
      ],
      headers1: [
        { title: "School Id", value: "school_id", align: "start" },
        { title: "First Name", value: "fname", align: "start" },
        { title: "Middle Name", value: "mname", align: "start" },
        { title: "Last Name", value: "lname", align: "start" },
        { title: "Suffix", value: "suffix", align: "start" },
        {
          title: "Actions",
          value: "actions",
          align: "center",
          sortable: false,
          width: 200,
        },
      ],
      programsList: [],
      fadeAwayMessage: {
        show: false,
        type: "success",
        header: "Successfully Added!",
        message: "",
        top: 10,
      },
      fetched_data: [],
      removedStudent: [],

      entry_type: null,
      entrytypeDialog: false,
      studentDialog: false,
      internal_action: null,
      student_id: null,
      students_data: [],
      debounceTimer: null,
      fname: null,
      mname: null,
      lname: null,
      suffix: null,
      sex: null,
      searching: false,
      search_output: null,
      tmp_student_id: null,
      tmp_canBeAdded: null,
      tmp_studentExist: null,
    };
  },
  components: {
    SkillAssessmentBatchDialog,
  },
  watch: {
    data: {
      handler(data) {
        this.dialog = true;
        this.entry_type = null;
        this.entrytypeDialog = true;
        this.initialize();
        this.removedStudent = [];
        // console.log(data);
        if (data.id) {
          // console.log("asdas", data);
          this.setName = data.name;
          this.program_id = data.program_id;
          this.batch_selected = data.student_batch_id.toString();
          // this.loadClasslist();
        } else {
          this.fetched_data = [];
          this.setName = null;
          this.program_id = null;
          this.batch_selected = null;
          this.csv_file = null;
        }

        this.$refs.ClassSetForm.resetValidation();
      },
      deep: true,
    },

    entry_type: {
      handler(val) {
        // only auto-load existing class data when editing AND an entry type has been picked
        if (val && this.data && this.data.id) {
          this.loadClasslist();
        }
      },
    },
    parsed: {
      handler(data) {
        if (data) {
          if (this.entry_type == 1) {
            this.fetchStudents();
          }
        }
      },
    },
    batch_selected: {
      handler(data) {
        if (data) {
          if (this.entry_type == 1) {
            this.fetchStudents();
          }
        }
      },
    },

    program_id: {
      handler(data) {
        if (data) {
          if (this.entry_type == 1) {
            this.fetchStudents();
          }
        }
      },
    },
  },
  computed: {
    // getProgramName() {
    //   let name = "";
    //   for (let i = 0; i < this.programsList.length; i++) {
    //     if (this.programsList[i].id == this.$store.state.user.program_id)
    //       name = this.programsList[i].name;
    //   }
    //   return name;
    // },
  },

  mounted() {
    eventBus.on("closeSkillAssessmentBatchDialog", () => {
      console.log("vcalled me");
      this.getBatchList();
    });
  },
  beforeUnmount() {
    eventBus.off("closeSkillAssessmentBatchDialog");
  },
  methods: {
    initialize() {
      this.getBatchList();
      this.getPrograms();
    },

    fetchStudents() {
      console.log("FETCHING .....");

      if (this.batch_selected && this.program_id && this.csv_results.data) {
        let data = {
          students: JSON.stringify(this.csv_results.data),
          batch_id: this.batch_selected,
          program_id: this.program_id,
        };
        this.axiosCall("/student/check-students", "POST", data).then((res) => {
          console.log(res);
          if (res.data.status == 200) {
            // console.log(res.data);
            this.fetched_data = res.data.data;
          }
        });
      }
    },

    loadClasslist() {
      this.axiosCall("/student/getMyStudentBySet/" + this.data.id, "GET").then(
        (res) => {
          if (res) {
            console.log(res.data);
            this.parsed = true;
            if (this.entry_type == 1) {
              this.fetched_data = res.data;
            } else {
              this.students_data = res.data;
            }
          }
        },
      );
    },

    showAddBatch() {
      console.log("SLEE", this.batch_selected);
      if (this.batch_selected == -1) {
        this.batch_group = { id: null };
      }
    },

    parseCSV() {
      Papa.parse(this.csv_file, {
        header: true,
        skipEmptyLines: true,
        complete: function (results) {
          this.csv_results = results;
          this.parsed = true;
        }.bind(this),
      });
    },

    remove(item, index) {
      this.itemToDelete = item;
      this.indexToDelete = index;
      this.dialogConfirmDelete = true;
    },

    proceedDelete() {
      this.removedStudent.push(this.itemToDelete);
      if (this.entry_type == 1) {
        this.fetched_data.splice(this.indexToDelete, 1);
      }

      if (this.entry_type == 2) {
        this.students_data.splice(this.indexToDelete, 1);
      }
      this.dialogConfirmDelete = false;
      this.fadeAwayMessage.show = true;
      this.fadeAwayMessage.type = "success";
      this.fadeAwayMessage.message = "Removed successfully";
      this.fadeAwayMessage.header = "System Message";
      this.itemToDelete = null;
      this.indexToDelete = null;
    },

    async save() {
      let validation = await this.$refs.ClassSetForm.validate();

      if (validation.valid) {
        let checkedList;
        if (this.entry_type == 1) {
          checkedList = this.fetched_data.filter(
            (data) => data.studentExist == false || data.canBeAdded == false,
          );
        } else {
          checkedList = this.students_data.filter(
            (data) => data.studentExist == false || data.canBeAdded == false,
          );
        }

        if (checkedList.length > 0) {
          this.btnLoading = false;
          this.fadeAwayMessage.show = true;
          this.fadeAwayMessage.type = "error";
          this.fadeAwayMessage.message =
            "Please remove student/s having status not OK";
          this.fadeAwayMessage.header = "System Message";
        } else {
          this.btnLoading = true;
          let data = {
            batch_id: this.batch_selected,
            student_list:
              this.entry_type == 1
                ? JSON.stringify(this.fetched_data)
                : JSON.stringify(this.students_data),
            set_name: this.setName,
            program_id: this.program_id,
          };
          this.axiosCall("/student/add-set", "POST", data).then((res) => {
            if (res.data.status == 201) {
              this.btnLoading = false;
              this.fadeAwayMessage.show = true;
              this.fadeAwayMessage.type = "success";
              this.fadeAwayMessage.message = "Added successfully";
              this.fadeAwayMessage.header = "System Message";
              this.closeD();
            } else {
              this.btnLoading = false;
              this.fadeAwayMessage.show = true;
              this.fadeAwayMessage.type = "error";
              this.fadeAwayMessage.message = res.data.msg;
              this.fadeAwayMessage.header = "System Message";
            }
          });
        }
      } else {
        this.btnLoading = false;
        this.fadeAwayMessage.show = true;
        this.fadeAwayMessage.type = "error";
        this.fadeAwayMessage.message = "Please fill in required field.";
        this.fadeAwayMessage.header = "System Message";
      }
    },

    async update() {
      let validation = await this.$refs.ClassSetForm.validate();

      if (validation.valid) {
        this.btnLoading = true;
        let data = {
          batch_id: this.batch_selected,
          student_list: JSON.stringify(this.fetched_data),
          set_name: this.setName,
          program_id: this.program_id,
          removedStudent: JSON.stringify(this.removedStudent),
          group_list_id: this.data.id,
        };
        this.axiosCall("/student/update-set", "POST", data).then((res) => {
          if (res.data.status == 200) {
            this.btnLoading = false;
            this.fadeAwayMessage.show = true;
            this.fadeAwayMessage.type = "success";
            this.fadeAwayMessage.message = res.data.msg;
            this.fadeAwayMessage.header = "System Message";
            this.closeD();
          } else {
            this.btnLoading = false;
            this.fadeAwayMessage.show = true;
            this.fadeAwayMessage.type = "error";
            this.fadeAwayMessage.message = res.data.msg;
            this.fadeAwayMessage.header = "System Message";
          }
        });
      }
    },

    addData() {
      if (!this.setName || !this.program_id || !this.batch_selected) {
        this.fadeAwayMessage.show = true;
        this.fadeAwayMessage.type = "error";
        this.fadeAwayMessage.message = "Please fill in required fields first.";
        this.fadeAwayMessage.header = "System Message";
        return;
      } else {
        this.searching = false;
        this.search_output = null;
        this.student_id = null;
        this.studentDialog = true;
        this.internal_action = "Add";
      }
    },

    findStudent() {
      let val = this.student_id;
      clearTimeout(this.debounceTimer);
      console.log(val);
      this.debounceTimer = setTimeout(() => {
        if (val) {
          this.getData(val);
        }
      }, 2000);
    },

    saveData() {
      if (this.$refs.ManualStudentForm.validate()) {
        this.students_data.push({
          student_id: this.tmp_student_id,
          canBeAdded: this.tmp_canBeAdded,
          studentExist: this.tmp_studentExist,
          school_id: this.student_id,
          fname: this.fname,
          mname: this.mname,
          lname: this.lname,
          suffix: this.suffix,
          sex: this.sex,
          email: this.email,
        });

        this.studentDialog = false;
        this.student_id = null;
        this.fname = null;
        this.mname = null;
        this.lname = null;
        this.suffix = null;
        this.email = null;
        this.tmp_student_id = null;
        this.tmp_canBeAdded = null;
        this.tmp_studentExist = null;
      }
    },

    getData(data) {
      this.searching = true;
      this.axiosCall(
        "/student/findByProgramAndBatchAndSchoolId/" +
          this.program_id +
          "/" +
          this.batch_selected +
          "/" +
          data,
        "GET",
      ).then((res) => {
        if (res.data) {
          this.searching = false;
          if (res.data.canBeAdded) {
            this.search_output = "found";

            this.tmp_student_id = res.data.id;
            this.school_id = res.data.school_id;
            this.fname = res.data.fname;
            this.mname = res.data.mname;
            this.lname = res.data.lname;
            this.suffix = res.data.suffix;
            this.sex = res.data.sex;
            this.email = res.data.email;
            this.tmp_canBeAdded = res.data.canBeAdded;
            this.tmp_studentExist = res.data.studentExist;
          } else {
            this.search_output =
              "Student already added on the other class/set.";
          }
        } else {
          this.searching = false;
          this.search_output = "Data not found";
        }
        console.log("retrun", res.data);
      });
    },

    closeD() {
      eventBus.emit("closeClassSetDialog", true);
      this.dialog = false;
    },

    getBatchList() {
      this.axiosCall("/student/get-batch-list", "GET").then((res) => {
        this.batchList = res.data;
      });
    },

    getPrograms() {
      this.axiosCall("/program/getProgramsByInstitute", "GET").then((res) => {
        this.programsList = res.data;
        // this.programs = this.programsList[this.programsList.length - 1].id;
      });
    },
  },
};
</script>
